module.exports = __webpack_public_path__ + "img/arrow.c2c0db5c.svg";